import React, { useEffect, useState } from 'react';

const withBackgroundImage = (WrappedComponent) => (props) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [lqImageLoaded, setLqImageLoaded] = useState(false);

    const { image } = props;
    const baseAssetPath = window.HELIOS.publicPath;
    const imagePath = `${baseAssetPath}images/navigation/${imageLoaded ? image : `${image}-lq`}.jpg`;

    useEffect(() => {
        if (image) {
            const lqImg = new Image();

            lqImg.src = `${baseAssetPath}images/navigation/${image}-lq.jpg`;
            lqImg.onload = () => setLqImageLoaded(true);

            const img = new Image();

            img.src = `${baseAssetPath}images/navigation/${image}.jpg`;
            img.onload = () => setImageLoaded(true);
        }
    }, []);

    const { className } = props;

    return (
        <section className={`Slide ${className} Slide__background`} style={{ backgroundImage: `url(${imagePath})` }}>
            <WrappedComponent {...props} className={lqImageLoaded ? 'background-loaded' : ''} noBackgroundMedia={false} />
        </section>
    );
};

export default withBackgroundImage;
